import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import { Mission } from '~/types/missionGameApi';
import { contentLight, themeColorLight } from '~/styles/themes';

type MissionItemProps = {
  mission: Mission;
  missionNum: number;
  answer?: string;
  onAnswerClick?: (answer: { answer: string; question_id: number }) => void;
};

const MissionItem = ({
  mission,
  missionNum,
  answer = '',
  onAnswerClick,
}: MissionItemProps) => {
  return (
    <MissionItemContainer>
      <MissionText missionNum={missionNum} question={mission.question} />
      <AnswerButton
        onClick={() => onAnswerClick?.({ answer, question_id: missionNum })}
      >
        <AnswerText
          style={{
            color:
              answer !== ''
                ? contentLight.content_light_4
                : themeColorLight.main_1,
          }}
        >
          {answer !== '' ? answer : 'Answer'}
        </AnswerText>
        <Icon iconName='ArrowRight' color={'main_1'} />
      </AnswerButton>
    </MissionItemContainer>
  );
};

export const MissionText = ({
  missionNum,
  question,
}: {
  missionNum: number;
  question: string;
}) => {
  return (
    <MissionTextContainer>
      <span>{`${missionNum}.`}</span>
      <span style={{ wordBreak: 'keep-all' }}>{question}</span>
    </MissionTextContainer>
  );
};

const MissionTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  color: ${({ theme }) => theme.colors.white};
  font-size: 16px;
  font-weight: 500;
  gap: 5px;
  word-break: keep-all;
`;

const MissionItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  gap: 12px;
`;

const AnswerText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AnswerButton = styled.div`
  display: flex;
  align-items: center;
  width: 'fit-content';
  max-width: 150px;
  height: 'fit-content';
`;

export default MissionItem;
